import React, { useContext, useEffect, useState } from 'react';
import Table from './PayoutsTable';
import CustomButton from '../../common/Button/Button';
import {
  DownOutlined,
  ExportOutlined,
  FilterOutlined,
  ReloadOutlined,
  SearchOutlined,
  ToolOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import colors from '../../../constants/ColourConstants';
import {
  AutoComplete,
  Button,
  ConfigProvider,
  Input,
  Pagination,
  Result,
  Tooltip,
  message,
  Dropdown,
} from 'antd';
import FiltersPane from './FiltersPane';
import {
  completeFailedPayout,
  getPayoutCSV,
  getPayouts,
  getRegenerateExport,
  getSearch,
  updatePayoutStatus,
} from '../../../services/PayoutAPIs';
import {
  LOCK_MSG,
  UPLOAD_PAYOUT_BATCH_UPDATES,
  UPLOAD_PAYOUT_DOTS_PRE_FAIL,
} from '../../../constants/ApiConstants';
import UpdatePyoutModal from './Modals/UpdatePayoutModal';
// import { handlePayoutPeriod } from '../../../utils/helpers/helper';
import ExportPyoutModal from './Modals/ExportModal';
import UploadFile from '../../common/Upload/UploadFile';
import RegenerateModal from './Modals/RegenerateModal';
import moment from 'moment';
import { AppFactsContext } from '../../common/Navigation/Navigation';

const getStatusType = (status) => {
  return (
    {
      'Ready for Finance Review': 'default',
      'Under Further Review': 'default',
      'Ready to Remit': 'cyan',
      'Payout Initiated': 'cyan',
      'Payout Pending': 'warning',
      'Payout Failure': 'error',
      'Payout Completed': 'success',
      'Reattempt Failed': 'error',
      'Pending Reattempt': 'default',
      'Reattempt Successful': 'success',
      Voided: 'default',
      Regenerated: 'default',
    }[status] || 'default'
  );
};

export const initFilters = {
  contributorEmail: '',
  country: [],
  fixedRangeForCreated: 'Last 30 days',
  reattempted: false,
  fixedRangeForCompleted: null,
  fixedRangeForVoided: null,
  payoutRail: [],
  // payoutPeriod: { month: [], year: [] },
  status: [],
  reattemptStatus: [],
  defaultRail: '',
  notes: { type: 'Contains', value: '' },
  failureNotes: { type: 'Contains', value: '' },
};

const Payouts = () => {
  const [payouts, setPayouts] = useState([]);

  const [tableId, setTableId] = useState(1);
  const [currentData, setCurrentData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRecords, setSelectedRecords] = useState([]);

  const [pageLoader, setPageLoader] = useState(true);
  const [tableLoader, setTableLoader] = useState(false);
  const [error, setError] = useState(false);

  const [openFilters, setOpenFilters] = useState(false);
  const [filterValues, setFilterValues] = useState(initFilters);
  const [messageApi, contextHolder] = message.useMessage();
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [openExportModal, setOpenExportModal] = useState(false);
  const [openRegenerateModal, setOpenRegenerateModal] = useState(false);
  const [failedPayoutsCount, setFailedPayoutsCount] = useState(null);

  const [searchLoader, setSearchLoader] = useState(false);
  const [searchOptions, setSearchOptions] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [searchDropdown, setSearchDropdown] = useState(false);
  const [payoutExpandedRowKeys, setPayoutExpandedRowKeys] = useState([]);
  const [exportLoader, setExportLoader] = useState(false);
  const [regenerationExportLoader, setRegenerationExportLoader] =
    useState(false);
  const [isRegeneratedDisable, setIsRegeneratedDisable] = useState(false);
  const [isUpdateDisable, setIsUpdateDisable] = useState(false);
  const [uploadModel, setUploadModel] = useState({
    open: false,
    key: 1,
    type: '',
    url: '',
  });
  const [sortField, setSortField] = useState({});

  const handlePageChange = (page) => setCurrentPage(page);

  const { appFacts } = useContext(AppFactsContext);

  useEffect(() => {
    const { regenerate_payouts, update_payouts } = appFacts;
    if (regenerate_payouts !== undefined) {
      setIsRegeneratedDisable(regenerate_payouts);
    }
    if (update_payouts !== undefined) {
      setIsUpdateDisable(update_payouts);
    }
  }, [appFacts?.regenerate_payouts, appFacts?.update_payouts]);

  useEffect(() => {
    !pageLoader && handleApplyFilters();
  }, [pageSize]);

  useEffect(() => {
    if (payouts[currentPage]) {
      setCurrentData(payouts[currentPage]);
    } else {
      handlePayouts();
    }
  }, [currentPage]);

  useEffect(() => {
    setCurrentData(payouts[currentPage]);
  }, [payouts]);

  useEffect(() => {
    handlePayouts();
  }, [sortField]);

  const handlePageSizeChange = (_current, size) => setPageSize(size);

  const handleSearch = (v) => {
    setSearchValue(v);
    if (v.length > 2) {
      setSearchLoader(true);
      let payout = getPayload();
      payout = { ...payout, searchTerm: v };
      getSearch(payout)
        .then((data) => {
          const options = data.map((d) => ({
            key: d,
            value: d,
          }));
          setSearchOptions(options);
        })
        .catch(() => {
          handleMessage('error', 'Unable to fetch Payouts');
        })
        .finally(() => {
          setSearchLoader(false);
        });
    } else {
      setSearchOptions([]);
    }
  };

  const handleSearchKey = (v) => {
    setSearchTerm(v || '');
    // handlePayouts({ searchTerm: v || '' });
    setSearchDropdown(false);
    setPayoutExpandedRowKeys([]);
    handleApplyFilters({ searchTerm: v || '' });
  };

  const handleShowUploadModal = (type) => {
    setUploadModel({
      open: true,
      key: uploadModel.key + 1,
      type: 'Update',
      url:
        type === 'Upload Batch Update'
          ? UPLOAD_PAYOUT_BATCH_UPDATES
          : type === 'Upload Dots Pre-Fail'
            ? UPLOAD_PAYOUT_DOTS_PRE_FAIL
            : '',
      title:
        type === 'Upload Batch Update'
          ? 'Upload Batch Update'
          : type === 'Upload Dots Pre-Fail'
            ? 'Upload Dots Pre-Fail File'
            : 'Upload',
    });
  };

  const uploadMenuItems = [
    {
      key: 'batch',
      icon: <UploadOutlined style={{ color: '#008080' }} />,
      label: 'Upload Batch Update',
      disabled: isUpdateDisable,
    },
    {
      key: 'dots',
      icon: <UploadOutlined style={{ color: '#008080' }} />,
      label: 'Upload Dots Pre-Fail',
      disabled: isUpdateDisable,
    },
  ];

  const onUploadMenuClick = ({ key }) => {
    handleShowUploadModal(
      key === 'batch' ? 'Upload Batch Update' : 'Upload Dots Pre-Fail',
    );
  };

  const handleExportCSV = async (exportType) => {
    setExportLoader(true);
    let payload = getPayload();
    if (exportType === 'selected') {
      payload = { payoutIdList: selectedRowKeys.toString() };
    }
    try {
      await getPayoutCSV(payload);
      handleMessage(
        'success',
        'payouts CSV file creation is in progress. Please check the batch updates.',
      );
    } catch {
      handleMessage('error', 'Unable to create payouts CSV file');
    } finally {
      setExportLoader(false);
    }
  };

  const handleRegenerateExport = async (Id) => {
    setRegenerationExportLoader(true);
    try {
      const data = await getRegenerateExport(Id);

      const blob = new Blob([data]);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      const timestamp = moment().format('YYYY-MM-DD_HH-mm-ss');
      link.setAttribute('download', `failed_export_${timestamp}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      handleMessage('success', 'Failed payouts CSV file is downloaded.');
    } catch {
      handleMessage('error', 'Unable to download failed payouts CSV file');
    } finally {
      setRegenerationExportLoader(false);
    }
  };

  const TableHeader = () => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: colors.colorSplit,
        margin: '-16px',
        padding: '8px',
      }}
    >
      <div
        style={{
          display: 'flex',
          gap: '16px',
          alignItems: 'center',
        }}
      >
        <Tooltip title={'Update Statuses & Notes'}>
          <CustomButton
            size="large"
            variant="outlined"
            icon={<ReloadOutlined />}
            onClick={() => setOpenUpdateModal(true)}
            shape="circle"
          />
        </Tooltip>
        <Tooltip title={'Export to CSV'}>
          <CustomButton
            size="large"
            loading={exportLoader}
            variant="outlined"
            onClick={() => setOpenExportModal(true)}
            icon={<ExportOutlined />}
            shape="circle"
          />
        </Tooltip>
        <Dropdown
          menu={{ items: uploadMenuItems, onClick: onUploadMenuClick }}
          trigger={['click']}
          getPopupContainer={() => document.body}
        >
          <CustomButton
            size="large"
            variant="outlined"
            disabled={isUpdateDisable}
            shape="round"
          >
            <UploadOutlined style={{ color: '#008080', marginRight: 6 }} />
            <DownOutlined style={{ color: '#008080' }} />
          </CustomButton>
        </Dropdown>
      </div>
      <div
        style={{
          display: 'flex',
          gap: '16px',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <CustomButton
          shape="round"
          type="default"
          variant="outlined"
          icon={<FilterOutlined />}
          size="large"
          onClick={() => setOpenFilters(true)}
        >
          Filter
        </CustomButton>
        <ConfigProvider
          theme={{
            token: {
              borderRadius: 100,
            },
          }}
        >
          <AutoComplete
            popupMatchSelectWidth={252}
            style={{
              width: 300,
            }}
            options={searchValue.length >= 3 && searchOptions}
            notFoundContent={
              (searchValue.length < 3 && 'Enter 3 letters for dropdown') ||
              (!searchLoader && searchOptions.length == 0 && 'No data found')
            }
            open={searchDropdown}
            onBlur={() => setSearchDropdown(false)}
            onSelect={(e) => {
              setSearchValue(e);
              setSearchDropdown(false);
            }}
            variant="borderless"
            size="large"
          >
            <div>
              <Input.Search
                size="large"
                value={searchValue}
                onSearch={handleSearchKey}
                onClear={handleSearchKey}
                onClick={() => setSearchDropdown(true)}
                allowClear
                placeholder="Search by payout id & contributor"
                enterButton={
                  <Button
                    type="primary"
                    loading={searchLoader}
                    icon={<SearchOutlined />}
                  />
                }
                variant="borderless"
                onChange={(e) => handleSearch(e.target.value)}
                style={{
                  backgroundColor: colors.colorWhite,
                  borderRadius: 20,
                }}
              />
            </div>
          </AutoComplete>
        </ConfigProvider>
      </div>
    </div>
  );

  const handleMessage = (type, content) => {
    messageApi.open({
      type: type,
      content: content,
      duration: 10,
    });
  };

  const getPayload = (method) => {
    const {
      contributorEmail,
      country,
      fixedRangeForCreated,
      'fixedRangeForCreated.customDates': createdDate,
      fixedRangeForCompleted,
      'fixedRangeForCompleted.customDates': completedDate,
      fixedRangeForVoided,
      'fixedRangeForVoided.customDates': voidedDate,
      payoutRail,
      reattempted,
      // 'payoutPeriod.month': month,
      // 'payoutPeriod.year': year,
      status,
      reattemptStatus,
      'notes.type': noteType,
      'notes.value': notes,
      'failureNotes.type': failureNotesType,
      'failureNotes.value': failureNotes,
      defaultRail,
      sortOrder,
    } = filterValues;

    const contains =
      notes == undefined || notes == null || notes == ''
        ? null
        : noteType == undefined ||
            noteType == null ||
            noteType == '' ||
            noteType == 'Contains'
          ? true
          : false;

    const containsFailureNotes =
      failureNotes == undefined || failureNotes == null || failureNotes == ''
        ? null
        : failureNotesType == undefined ||
            failureNotesType == null ||
            failureNotesType == '' ||
            failureNotesType == 'Contains'
          ? true
          : false;

    let payload_map = {};
    if (method === 'post') {
      payload_map = {
        // month,
        status,
        reattemptStatus,
        payoutRail,
        country,
        contributorEmail: contributorEmail ? contributorEmail?.split(',') : [],
      };
    } else {
      payload_map = {
        // month: month?.filter((i) => i).toString(),
        status: status?.filter((i) => i).toString(),
        reattemptStatus: reattemptStatus?.filter((i) => i).toString(),
        payoutRail: payoutRail?.filter((i) => i).toString(),
        country: country?.filter((i) => i).join(';'),
      };
    }

    return {
      searchTerm: searchTerm,
      contributorEmail,
      fixedRangeForCreated,
      defaultRail,
      reattempted,
      createdStartDate: createdDate?.[0],
      createdEndDate: createdDate?.[1],
      fixedRangeForCompleted,
      completedStartDate: completedDate?.[0],
      completedEndDate: completedDate?.[1],
      fixedRangeForVoided,
      voidedStartDate: voidedDate?.[0],
      voidedEndDate: voidedDate?.[1],
      // year: year,
      ...payload_map,
      notes,
      contains,
      failureNotes,
      containsFailureNotes,
      [sortField.field]: sortField?.order,
      page: currentPage,
      size: pageSize,
      order: sortOrder,
    };
  };

  const payout_locked_status = [
    'Payout Initiated',
    'Payout Pending',
    'Payout Failure',
    'Payout Completed',
    'Reattempt Failed',
    'Pending Reattempt',
    'Reattempt Successful',
    'Voided',
    'Regenerated',
  ];

  const transformData = (data) => {
    const { rows, columns } = data;
    let map = rows.map((row) => {
      return columns.reduce((obj, col, index) => {
        obj[col] = row[index];
        obj['key'] = obj['payoutId'];
        return obj;
      }, {});
    });
    map = map.map((payouts) => {
      return {
        ...payouts,
        payoutsGrandTotal: payouts.payoutsGrandTotal
          ? `$ ${payouts['payoutsGrandTotal']}`
          : '-',
        statusType: getStatusType(payouts['status']),
        isLocked: payout_locked_status.includes(payouts['status']),
        striked: payouts['status'] === 'Voided' ? true : false,
        reattemptStatusType: getStatusType(payouts['reattemptStatus']),
        payoutCreatedDate: payouts['payoutCreatedDate'].split('T')[0],
        completedDate:
          payouts['completedDate'] && payouts['completedDate'].split('T')[0],
        voidedDate:
          payouts['voidedDate'] && payouts['voidedDate'].split('T')[0],
        // payoutPeriod: handlePayoutPeriod(payouts['payoutPeriod']),
      };
    });
    return map;
  };

  const handlePayouts = (rest) => {
    setTableLoader(true);
    let payload = getPayload();
    payload = { ...payload, ...rest };
    getPayouts(payload)
      .then((data) => {
        setPayouts({
          ...payouts,
          [`${data.pagination.currentPage}`]: transformData(data),
        });
        setTotalRecords(data?.pagination?.totalRows || 0);
        setFailedPayoutsCount(data?.payoutCount);
      })
      .catch(() => {
        setError(true);
        handleMessage('error', 'Unable to fetch payouts');
      })
      .finally(() => {
        setTableLoader(false);
        setPageLoader(false);
      });
  };

  const handleRowSelection = (keys, record) => {
    setSelectedRowKeys(keys);
    setSelectedRecords(record);
  };

  const handleApplyFilters = (rest) => {
    setOpenFilters(false);
    setTableId(() => tableId + 1);
    setSelectedRowKeys(() => {
      return [];
    });
    setSelectedRecords(() => {
      return [];
    });
    setPayouts(() => {
      return {};
    });
    setCurrentPage(() => {
      return 1;
    });
    if (currentPage !== 1) {
      setCurrentPage(() => {
        return 1;
      });
    } else {
      handlePayouts(rest);
    }
  };

  function handleApplysort(rest) {
    setTableId(() => tableId + 1);
    setSelectedRowKeys(() => {
      return [];
    });
    setSelectedRecords(() => {
      return [];
    });
    setPayouts(() => {
      return {};
    });
    setCurrentPage(() => {
      return 1;
    });
    setSortField(() => {
      return rest;
    });
  }

  const handlePayoutsStatusUpdate = (type, rowId, payload) => {
    setTableLoader(true);
    setOpenUpdateModal(false);

    let keys = [];
    let filter = null;
    let is_query = false;

    if (type === 'single') {
      keys = [rowId];
    } else if (type === 'selected') {
      let selectedRowKeys = [];
      selectedRecords.map((ele) => {
        if (!ele.isLocked) {
          selectedRowKeys.push(ele.payoutId);
        }
      });
      keys = selectedRowKeys;
    } else if (type === 'query') {
      is_query = true;
      filter = getPayload('post');
    }

    updatePayoutStatus(keys, filter, payload)
      .then((res) => {
        if (res === LOCK_MSG) {
          handleMessage(
            'error',
            'System is Locked for any updates,Please try after some time.',
          );
        } else {
          if (keys.length <= 10 && !is_query) {
            if (res?.failedPayoutIds?.length > 0) {
              handleMessage(
                'error',
                `Couldn't update ${res?.failedPayoutIds?.length} payouts. `,
              );
            } else if (res?.successfullPayouts > 0) {
              handleMessage('success', 'Successfully updated payout statuses');
            }
          } else {
            handleMessage(
              'success',
              'Updating Status is in progress,Please check the batch updates.',
            );
          }
          handleApplyFilters();
        }
      })
      .catch(() => {
        handleMessage('error', 'Failed to update payouts statuses & notes');
      })
      .finally(() => {
        setTableLoader(false);
      });
  };

  const getCompleteFailedPayoutErrorMessage = (res) => {
    const data = res?.data;
    if (typeof data === 'string' && data) {
      return data;
    }
    return data?.errorMessage || 'Failed to complete the payout';
  };

  const handleCompleteFailedPayout = (payoutId, payload) => {
    setTableLoader(true);
    return completeFailedPayout(payoutId, payload)
      .then((res) => {
        if (!res || res.status >= 400) {
          handleMessage('error', getCompleteFailedPayoutErrorMessage(res));
          return false;
        }
        if (res.data === LOCK_MSG) {
          handleMessage(
            'error',
            'System is Locked for any updates,Please try after some time.',
          );
          return false;
        }
        handleMessage(
          'success',
          `Payout ${payoutId} moved to Payout Completed.`,
        );
        handleApplyFilters();
        return true;
      })
      .catch(() => {
        handleMessage('error', 'Failed to complete the payout');
        return false;
      })
      .finally(() => {
        setTableLoader(false);
      });
  };

  const handleActionButtons = () => {
    return (
      <CustomButton
        icon={<ToolOutlined />}
        onClick={() => setOpenRegenerateModal(true)}
        disabled={isRegeneratedDisable}
      >
        Regenerate Failed Payouts
      </CustomButton>
    );
  };

  return (
    <>
      {contextHolder}
      {error ? (
        <Result
          status="500"
          title="500"
          subTitle="Sorry, something went wrong."
        />
      ) : (
        <>
          {handleActionButtons()}
          <Table
            key={`table-${tableId}`}
            title={TableHeader}
            loading={tableLoader}
            data={currentData}
            handleRowSelection={handleRowSelection}
            selectedRowKeys={selectedRowKeys}
            handleSort={handleApplysort}
            sortField={sortField}
            handlePayoutsStatusUpdate={handlePayoutsStatusUpdate}
            payoutExpandedRowKeys={payoutExpandedRowKeys}
            setPayoutExpandedRowKeys={setPayoutExpandedRowKeys}
            handlePayouts={handlePayouts}
            handleCompleteFailedPayout={handleCompleteFailedPayout}
          />
          <Pagination
            style={{
              padding: '16px 0',
              display: 'flex',
              justifyContent: 'end',
            }}
            pageSize={pageSize}
            current={currentPage}
            total={totalRecords}
            showSizeChanger={true}
            onChange={handlePageChange}
            onShowSizeChange={handlePageSizeChange}
          />
          <FiltersPane
            openFilters={openFilters}
            filterValues={filterValues}
            setFilterValues={setFilterValues}
            setOpenFilters={setOpenFilters}
            handleApply={handleApplyFilters}
          />
          <UpdatePyoutModal
            n={selectedRowKeys.length}
            onOk={handlePayoutsStatusUpdate}
            open={openUpdateModal}
            setOpen={setOpenUpdateModal}
            count={totalRecords}
            selectedRows={selectedRecords}
          />

          <ExportPyoutModal
            n={selectedRowKeys.length}
            open={openExportModal}
            setOpen={setOpenExportModal}
            count={totalRecords}
            query={getPayload()}
            selected={selectedRowKeys}
            handleExportCSV={handleExportCSV}
          />

          <UploadFile
            key={uploadModel.key}
            visible={uploadModel.open}
            type={uploadModel.type}
            onClose={() => setUploadModel(false)}
            url={uploadModel.url}
            title={uploadModel.title}
          />
          <RegenerateModal
            open={openRegenerateModal}
            setOpen={() => setOpenRegenerateModal(false)}
            disabled={isRegeneratedDisable}
            filterCount={totalRecords}
            filterFailed={failedPayoutsCount?.filteredFailedCount}
            selectedRows={selectedRecords}
            filter={getPayload('post')}
            handlePayouts={() => handleApplyFilters()}
            handleExport={handleRegenerateExport}
            failedExportLoader={regenerationExportLoader}
          />
        </>
      )}
    </>
  );
};

export default Payouts;
